import Fab from '@mui/material/Fab';
import { styled } from '@mui/material/styles';

export const FabLeft = styled(Fab)(
  ({ theme }) => ({
    position: 'absolute',
    top: 'calc(50% - 1.75rem)',
    left: '-1.75rem',
    border: `1px solid ${theme.palette.focus00.main}`,
    backgroundColor: theme.palette.focus80.main,

    '&:hover': {
      backgroundColor: theme.palette.btnFocusPrimaryHover.main,
      boxShadow: 'none'
    }
  })
);

export const FabRight = styled(Fab)(
  ({ theme }) => ({
    position: 'absolute',
    top: 'calc(50% - 1.75rem)',
    right: '-1.75rem',
    border: `1px solid ${theme.palette.focus00.main}`,
    backgroundColor: theme.palette.focus80.main,

    '&:hover': {
      backgroundColor: theme.palette.btnFocusPrimaryHover.main,
      boxShadow: 'none'
    }
  })
);
